Bingo.CustomerForm = {};
Bingo.CustomerForm.PersonForm = {};

Bingo.CustomerForm.initSwitcher = (switcherName, activeType) => {
    const radios = $('[name="'.concat(switcherName, '"]'));
    if (activeType) {
        $('[name="'.concat(switcherName, '"][value="', activeType, '"]')).prop('checked', true);
    }

    switchForms = () => {
        const value = $('[name="'.concat(switcherName, '"]:checked')).val();
        radios.each((i) => {
            const curVal = $(radios[i]).val();
            if (curVal === value) {
                $('#'.concat(curVal)).show();
            } else {
                $('#'.concat(curVal)).hide();
            }
        });
    };

    switchForms();
    radios.on('click', () => {
        switchForms();
    });
};


Bingo.CustomerForm.initDetail = (buttonShowId, buttonHideId, detailId, isHidden) => {
    const buttonShow = $('#'.concat(buttonShowId));
    const buttonHide = $('#'.concat(buttonHideId));
    const detail = $('#'.concat(detailId));


    buttonShow.on('click', (e) => {
        e.preventDefault();
        detail.show();
        buttonShow.hide();
    });

    buttonHide.on('click', (e) => {
        e.preventDefault();
        detail.hide();
        buttonShow.show();
    });

    if (isHidden) {
        detail.hide();
        buttonShow.show();
    } else {
        detail.show();
        buttonShow.hide();
    }
};
